<template>
	<!-- BEGIN login -->
	<div class="login login-with-news-feed">
		<!-- BEGIN news-feed -->
		<div class="news-feed">
			<div class="news-image" style="background-image: url(/assets/img/login-bg/login-bg-10.jpg)"></div>
			<div class="news-caption">
				<h4 class="caption-title" v-html="siteName"></h4>
				<p>
					Здесь вы можете получить живых подписчиков и лайки во всех соц. сетях, поднять посещаемость вашего
					сайта, раскрутить любой ваш проект или набрать
					рефералов на другие проекты. Только живой трафик, быстрое и
					качественное выполнение ваших заказов.
				</p>
			</div>
		</div>
		<!-- END news-feed -->

		<!-- BEGIN login-container -->
		<div class="login-container">
			<!-- BEGIN login-header -->
			<div class="login-header mb-30px">
				<div class="brand">
					<div class="d-flex align-items-center">
						<span v-html="siteName"></span>
					</div>
					<small>Биржа простых задач</small>
				</div>
				<div class="icon">
					<i class="fa fa-sign-in-alt"></i>
				</div>
			</div>
			<!-- END login-header -->

			<!-- BEGIN login-content -->
			<div class="login-content">
				<validation-observer ref="form">
					<form v-on:submit="checkForm" method="GET" class="fs-13px">


						<validation-provider #default="{ errors }" name="password" rules="required|min:6|max:16"
							vid="password">
							<div class="form-floating mb-15px">
								<input type="password" v-model="password" class="form-control h-45px fs-13px"
									placeholder="Password" id="password" />

								<label for="password"
									class="d-flex align-items-center fs-13px text-gray-600">Пароль</label>
								<small class="text-danger">{{ errors[0] }}</small>

							</div>
						</validation-provider>

						<validation-provider #default="{ errors }" name="password_confirmation"
							rules="required|min:6|max:16|confirmed:password" vid="password_confirmation">
							<div class="form-floating mb-15px">
								<input type="password" v-model="password_confirmation"
									class="form-control h-45px fs-13px" placeholder="Password"
									id="password_confirmation" />

								<label for="password_confirmation"
									class="d-flex align-items-center fs-13px text-gray-600">Повторить
									пароль</label>
								<small class="text-danger">{{ errors[0] }}</small>

							</div>
						</validation-provider>


						<div class="mb-15px">
							<button :disabled="loading || !password_confirmation || !password" type="submit"
								class="btn btn-primary d-block h-45px w-100 btn-lg fs-14px">
								<i v-show="loading" class="fas fa-circle-notch fa-spin"></i>
								Войти
							</button>
						</div>
						<div class="mb-40px pb-40px text-dark">
							Нет аккаунта? <router-link to="/register" class="text-primary">Зарегистрируйтесь
							</router-link><br>
						</div>
						<hr class="bg-gray-600 opacity-2" />
						<div class="text-gray-600 text-center text-gray-500-darker mb-0"
							v-html="`&copy; ` + siteName + ` All Right Reserved 2022`">
						</div>
					</form>
				</validation-observer>
			</div>
			<!-- END login-content -->
		</div>
		<!-- END login-container -->
	</div>
	<!-- END login -->
</template>

<script>
import AppOptions from '../config/AppOptions.vue'
import HTTP from "../http";
import { show_error } from "../message";
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email, max, min } from 'vee-validate/dist/rules';
extend('required', required);
extend('email', email);
extend('min', min);
extend('max', max);

export default {
	components: {
		ValidationProvider,
		ValidationObserver
	},
	data() {
		return {
			password_confirmation: "",
			password: "",
			hash: null,
			loading: false,
			errors: null,
			value: '',
			siteName: ''
		};
	},

	created() {
		AppOptions.appEmpty = true;
		this.email = this.$route.params.email
		this.siteName = process.env.VUE_APP_SITE_NAME
		this.checkSignature();
	},
	beforeRouteLeave(to, from, next) {
		AppOptions.appEmpty = false;
		next();
	},
	methods: {

		checkSignature() {
			this.$insProgress.start();
			this.loading = true;
			HTTP()
				.get("reset-password/" + this.$route.params.email + '?signature=' + this.$route.query.signature)
				.then((resp) => {
					this.hash = resp.data
					console.log('resp', resp)
				})
				.catch((error) => {
					show_error(this.$notify, this.$refs.form, error.response.data)
				})
				.finally(() => {
					this.loading = false;
				})
		},

		checkForm: function (e) {
			this.$refs.form.validate().then(success => {
				e.preventDefault();
				if (!success) {
					return;
				}
				this.$insProgress.start();
				this.loading = true;
				HTTP()
					.post("reset-password/", {
						email: this.email, token: this.hash, password: this.password, password_confirmation: this.password_confirmation
					})
					.then((resp) => {
						localStorage.setItem("user", JSON.stringify(resp.data.user));
						localStorage.setItem("token", JSON.stringify(resp.data.token.token));
						this.$router.push({ name: 'Home' })
					})
					.catch((error) => {
						show_error(this.$notify, this.$refs.form, error.response.data)
					})
					.finally(() => {
						this.loading = false;
						this.$insProgress.finish();
					});
			});

		},
	}
}
</script>